import {StatisticsTabsType} from './GameStatisticsStore.constants';

export interface GameStatisticsState {
  activeTab: StatisticsTabsType;
  personal: PersonalGameStatistics;
  projectDT: ProjectGameStatisticsItem[] | null;
}

export enum PersonalGameStatisticsItem {
  PersonalEnergyMultiplier = 'PersonalEnergyMultiplier',
  PersonalEnergyRechargers = 'PersonalEnergyRechargers',
  PersonalIncomePerHour = 'PersonalIncomePerHour',
  PersonalActiveGems = 'PersonalActiveGems',
  PersonalPassiveGems = 'PersonalPassiveGems',
  PersonalImprovements = 'PersonalImprovements',
  PersonalImprovementUpgrades = 'PersonalImprovementUpgrades',
  PersonalGifts = 'PersonalGifts',
  PersonalTasks = 'PersonalTasks',
  PersonalDailyGames = 'PersonalDailyGames',
  PersonalTickets = 'PersonalTickets',
  PersonalEnergySpent = 'PersonalEnergySpent',
  PersonalEnergyRechargersSpent = 'PersonalEnergyRechargersSpent',
  PersonalGemsSpent = 'PersonalGemsSpent',
  PersonalLeagueProgress = 'PersonalLeagueProgress',
}

export interface PersonalGameStatistics {
  energyMultiplier: number; // значение мультитапа
  energyRechargers: number; //сколько заработано батареек
  incomePerHour: number; //доход в час
  activeGems: number; // заработано кристаллов за тапы (активно)
  passiveGems: number; //заработано кристаллов за улучшения (пассивно)
  improvements: number; // кол-во купленных улучшений (первого уровня)
  improvementUpgrades: number; // кол-во прокаченных улучшений (прокачено выше первого уровня)
  gifts: number; // кол-во полученных призов
  tasks: number; //кол-во выполненных заданий
  dailyGames: number; //кол-во завершенных мини-игр
  tickets: number; // кол-во билетиков на розыгрыш
  energySpent: number; // количество тапов
  energyRechargersSpent: number; // потраченные батарейки
  gemsSpent: number; // потраченные кристаллики
  leagueProgress: GameStatisticsLeagueProgress[];
}

export interface GameStatisticsLeagueProgress {
  periodNumber: number;
  rank: number;
  league: {
    from: 0 | 1 | 2 | 3;
    to: 0 | 1 | 2 | 3;
  };
}

export interface ProjectGameStatisticsItem {
  id: string;
  name: string;
  value: string;
}
